<template>
 <page-container>
  <template v-slot:page-fixed-header>
    <span class="text-h5 font-weight-bold ml-3 page-header">
      {{ $t("SoftwareLicensePolicy") }}
      </span>      
      <v-spacer></v-spacer>
      <a-btn        
        color = "primary"
        :disabled="page > 1 ? false : true"        
        @click="page > 1 ? page-- : 1"
        
      >
        <v-icon>mdi-chevron-left</v-icon> {{ $t("Previous") }}</a-btn
      >
      <v-spacer></v-spacer>
      <span v-if="numPages" class="font-weight-bold mt-2" > {{ page }} / {{ numPages ? numPages : "∞" }}</span>
      <v-spacer></v-spacer>
      <a-btn
        color = "primary"
        :disabled="page < numPages ? false : true"
        @click="page < numPages ? page++ : 1"
        
      >
        {{ $t("Next") }}<v-icon>mdi-chevron-right</v-icon></a-btn
      >
      <v-spacer></v-spacer>
  </template>
  <template v-slot:page-content>
      <v-row>
        <v-col cols="12">
          <PDFViewer
            :documentPath="pdfFilePath"
            :page.sync="page"
            v-model="numPages"
          />
        </v-col>
      </v-row>
      <Loader :loading="loaderloading" :message="loaderText"></Loader>
  </template>
 </page-container>
</template>

<script>
import PDFViewer from "../components/dashboard/PDFViewer.vue";
import Loader from "@/components/Loader.vue";
export default {
  name: "LicensePolicy",
  components: {
    PDFViewer,
    Loader,
  },
  data() {
    return {
      pdfFilePath: "Open.Source.Software.License.pdf",
      page: 1,
      numPages: 0,
      scale: "page-width",
    };
  },
  computed: {
    loaderloading() {
      return this.numPages <= 0;
    },
    loaderText() {
        return this.$t("LoaderText");
    },
  },
};
</script>
